import Axios from 'axios'
import { store } from '../store'
import config from '../api/constants'
import { RESET_USER, RESET_OFFERS, RESET_AUTH, RESET_ACCOUNTS, RESET_APP, RESET_BILLERS } from './constants'
import { setLogout } from '../actions'
import http from '../api/api'

export const kikRefreshToken = async () => {
  try {
    const { auth, app } = store.getState()
    await http.post(config.apiRoute.REFRESH_TOKEN, {
      requestId: 'REFRESHLOGIN',
      module: 'LOGIN',
      refreshToken: auth?.refreshToken,
      userName: app?.loginDetails?.userName,
    })
    // if(response.status === 200){

    // }
  } catch (err) {
    clearStore()
  }
}

export const kickUser = async () => {
  try {
    await Axios.post(config.apiRoute.LOGOUT)
    clearStore()
  } catch (err) {
    clearStore()
  }
}

export const clearStore = async () => {
  // store.dispatch({ type: RESET_USER })
  // store.dispatch({ type: RESET_OFFERS })
  // store.dispatch({ type: RESET_AUTH })
  // store.dispatch({ type: RESET_ACCOUNTS })
  // store.dispatch({ type: RESET_APP })
  // store.dispatch({ type: RESET_BILLERS })
  if (!window.location.hash.endsWith('#/login')) {
    store.dispatch(setLogout(true))
  }
}
